import { Flex } from 'antd';
import React, { memo } from 'react'
import { TailSpin } from 'react-loader-spinner';

type Props = {
  size?: number;
  className?: string;
  justify?: React.CSSProperties['justifyContent'];
  color?: string;
  strokeWidth?: number | string;
}

function AppLoader({ size = 80, className = "py-3", justify = "center", color, strokeWidth }: Props) {
  return (
    <Flex justify={justify} className={className}>
      <TailSpin
        height={size}
        width={size}
        color={color || "#677ab1"}
        strokeWidth={strokeWidth}
        radius="1"
      />
    </Flex>
  )
}

export default memo(AppLoader);